module.exports = __webpack_public_path__ + "static/gq-spend-get-phase2-web-if-offers-banner-gemnz-mobile-b7f48f60157ac7d24a9f7697caec2fce.png";